<template lang="pug">
  .auth--confirm
    img.auth__logo(:alt="appName" :src="logoPath")

    //- Success confirm
    .text--center(v-if="success")
      van-icon(name="succes")
      h1 {{ $t('messages.validateEmail.title')}}
      p {{ $t('messages.validateEmail.message')}}

    //- Fails confirm
    .text--center(v-if="fails")
      van-icon(name="error")
      h1 {{ $t('errors.expireEmail.title')}}
      p {{ $t('errors.expireEmail.message')}}

      form.auth__form(@submit.prevent="sendEmailConfirm")
        input(
          type="email"
          name="email"
          v-model="email"
          v-validate="'required|email'"
          :data-vv-as="$t('email')"
          :class="{'error': errors.has('email') }"
          :placeholder="$t('email')")

        .margin-halve-top
          .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}

        van-button(
          size="large"
          type="primary"
          native-type="submit") {{ $t('send')}}

    //- Succes send email confirm
    .text--center(v-if="successSendEmail")
      van-icon(name="succes")
      h1 {{ $t('messages.resendToken.title')}}
      p {{ $t('messages.resendToken.message')}}

    //- Fails send email confirm
    .text--center(v-if="failsSendEmail")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}
</template>

<script>
import i18n from "@/i18n";
import axios from "axios";
import router from "@/router";
import { PROYECT } from "@/constant";

export default {
  data() {
    return {
      appName: PROYECT.NAME,
      logoPath: `/${PROYECT.LOGO}.svg`,
      email: "",
      error: "",
      success: false,
      fails: false,
      successSendEmail: false,
      failsSendEmail: false
    };
  },
  methods: {
    sendEmailConfirm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$toast.loading({
            duration: 0,
            mask: true,
            message: i18n.t("loading")
          });
          this.fails = false;

          axios({
            url: `auth/resendToken/${this.email}/${PROYECT.HOST}`,
            method: "GET"
          })
            .then(() => {
              this.$toast.clear();
              this.successSendEmail = true;
            })
            .catch(() => {
              this.$toast.clear();
              this.failsSendEmail = true;
            });
        }
      });
    }
  },
  created() {
    /*
     * BRIDGE no tiene habilitada esta funcionalidad,
     * si alguien llega aquí lo redirijo al home
     */
    if (PROYECT.HOST === "AZ") {
      router.push({ name: "home" });
    }

    this.$toast.loading({
      duration: 0,
      mask: true,
      message: i18n.t("loading")
    });

    const { token } = this.$route.params;

    axios({ url: `auth/confirmSignup/${token}`, method: "GET" })
      .then(() => {
        this.$toast.clear();
        this.success = true;
      })
      .catch(() => {
        this.$toast.clear();
        this.fails = true;
      });
  }
};
</script>
